import { render, staticRenderFns } from "./VTreeview.vue?vue&type=template&id=d04a8ebe&scoped=true&"
import script from "./VTreeview.vue?vue&type=script&lang=js&"
export * from "./VTreeview.vue?vue&type=script&lang=js&"
import style0 from "./VTreeview.vue?vue&type=style&index=0&id=d04a8ebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04a8ebe",
  null
  
)

export default component.exports